const API_URL = import.meta.env.VITE_API_URL;
const APP_NAME = import.meta.env.VITE_APP_NAME;
const GOOGLE_AUTH_ID = import.meta.env.VITE_GOOGLE_AUTH_ID;
const APPLICATION_ID = import.meta.env.VITE_APPLICATION_ID;
const DEBUG = import.meta.env.VITE_DEBUG === "true";

export { API_URL, APP_NAME, DEBUG, APPLICATION_ID, GOOGLE_AUTH_ID };
